// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"PlasmicLoadingPlaceholder_placeholder__Wes65"};